// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {useState} from 'react'

const ToggleContent = ({toggle, content}) => {
  const [isShown, setIsShown] = useState(false)
  const hide = () => setIsShown(false)
  const show = () => setIsShown(true)

  return (
    <>
      {toggle(show)}
      {isShown && content(hide)}
    </>
  )
}

export default ToggleContent
